import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'tabletRadio', 'desktopRadio']

  declare readonly containerTarget: HTMLElement
  declare readonly tabletRadioTarget: HTMLInputElement
  declare readonly desktopRadioTarget: HTMLInputElement

  connect (): void {
    this.applyViewport()
    this.containerTarget.classList.add('viewport-initialized')
  }

  applyViewport (): void {
    const sizeClasses = ['max-w-md', 'w-full']
    this.containerTarget.classList.remove(...sizeClasses)

    if (this.tabletRadioTarget.checked) {
      this.containerTarget.classList.add('max-w-md')
      this.containerTarget.dataset.viewport = 'tablet'
    } else if (this.desktopRadioTarget.checked) {
      this.containerTarget.classList.add('w-full')
      this.containerTarget.dataset.viewport = 'desktop'
    }
  }

  switchViewport (): void {
    this.applyViewport()
  }
}
